export const quotePricing = {
  perMile: 0,
  estimatedMiles: 0,
  fixedUpfront: 0,
  extras: 0,
  projectedAnnual: 0, // estimate miles times perMile plus upfront and extras.
  averageMonthly: 0, // estimate miles times perMile divided by 12
}
